import {useNavigation} from '@react-navigation/native';
import React, {useState, useEffect, useCallback} from 'react';
import {
  View,
  Text,
  FlatList,
  Pressable,
  TextInput,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  TouchableWithoutFeedback,
  Keyboard,
  ActivityIndicator,
  TouchableOpacity,
  Image,
  Alert,
  Linking,
} from 'react-native';
import Header from '../../components/Header/Header';
import {styles} from './styles';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import Toast from '../../components/Toast/Toast';
import {Colors} from '../../constants/Colors';
import {NavigationProps} from '../../navigation/Routes';
import {AppRoutes} from '../../navigation/Routes.types';
import {launchCamera, launchImageLibrary} from 'react-native-image-picker';
import {check, request, PERMISSIONS, RESULTS} from 'react-native-permissions';
import ExchangeProductsService from '../../services/ExchangeProductsService/ExchangeProductsService';
import {Image as Compressor} from 'react-native-compressor';
import RNFS from 'react-native-fs';

import ProductsService from '../../services/ProductsService/ProductsService';
import {useUserStore} from '../../store/UserStore';
import {getAnalytics, logEvent} from '@react-native-firebase/analytics';

const ExchangeProduct = ({route}) => {
  const {goBack} = useNavigation();
  const {item, canExchange} = route?.params;

  const [catalogData, setCatalogData] = useState<Array<Object>>([]);
  const {user} = useUserStore();

  const {navigate} = useNavigation<any>();
  const [toast, setToast] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const [selectedReason, setSelectedReason] = useState(null);
  const [otherReason, setOtherReason] = useState('');

  const [products, setProducts] = useState([]);

  const [validationError, setValidationError] = useState('');

  const [showModal, setShowModal] = useState(false);
  const analyticsInstance = getAnalytics();
  useEffect(() => {
    const items = Array.isArray(item.Itens?.Item)
      ? item.Itens?.Item
      : [item.Itens?.Item];

    setProducts(
      items.map(item => ({
        reason: '',
        description: '',
        quantity: 0,
        image: null,
        imageTooLarge: false,
        ...item,
      })),
    );
  }, [item]);

  useEffect(() => {
    const fetchData = async () => {
      if (!item?.Itens?.Item) return;

      let matnrList = [];
      if (Array.isArray(item.Itens.Item)) {
        matnrList = item.Itens.Item.map(i => i.MATNR).filter(Boolean);
      } else {
        matnrList = [item?.Itens?.Item?.MATNR];
      }

      try {
        const responses = await Promise.all(
          matnrList.map(async matnr => {
            const response = await ProductsService.catalogProductsGet(
              user?.clientCode,
              1,
              1,
              undefined,
              undefined,
              undefined,
              undefined,
              matnr,
            );
            return response?.data?.products[0];
          }),
        );

        setCatalogData(responses);
        setLoading(false);
      } catch (error) {
        Alert.alert('Erro ao carregar produtos, tente novamente mais tarde!');
      }
    };

    fetchData();
  }, [item]);

  const requestCameraPermission = async () => {
    if (Platform.OS === 'android') {
      try {
        const permission = PERMISSIONS.ANDROID.CAMERA;

        const result = await check(permission);

        if (result === RESULTS.GRANTED) return true;

        if (result === RESULTS.DENIED || result === RESULTS.LIMITED) {
          const requestResult = await request(permission);
          return requestResult === RESULTS.GRANTED;
        }

        if (result === RESULTS.BLOCKED) {
          Alert.alert(
            'Permissão negada',
            'Você bloqueou a permissão da câmera. Vá nas configurações do app para ativar.',
            [
              {text: 'Cancelar', style: 'cancel'},
              {
                text: 'Abrir configurações',
                onPress: () => Linking.openSettings(),
              },
            ],
          );
          return false;
        }

        return false;
      } catch (err) {
        console.warn('asdasdas');
        return false;
      }
    } else {
      return true;
    }
  };

  const openImageOptions = async index => {
    Alert.alert('Selecionar Imagem', 'Escolha uma opção', [
      {
        text: 'Câmera',
        onPress: async () => {
          const hasPermission = await requestCameraPermission();
          if (!hasPermission) {
            Alert.alert(
              'Permissão necessária',
              'Por favor, conceda permissão para a câmera nas configurações do app',
              [
                {text: 'Cancelar', style: 'cancel'},
                {
                  text: 'Abrir configurações',
                  onPress: () => Linking.openSettings(),
                },
              ],
            );
            return;
          }

          launchCamera(
            {mediaType: 'photo', saveToPhotos: false},
            handleImageResponse(index),
          );
        },
      },
      {
        text: 'Galeria',
        onPress: () => {
          launchImageLibrary({mediaType: 'photo'}, handleImageResponse(index));
        },
      },
      {text: 'Cancelar', style: 'cancel'},
    ]);
  };

  const handleImageResponse = index => async response => {
    if (response.didCancel) return;
    if (response.errorCode) {
      return;
    }

    if (response.assets?.length) {
      const asset = response.assets[0];

      try {
        // Comprimir imagem mantendo proporção
        const compressedUri = await Compressor.compress(asset.uri, {
          maxWidth: 1280,
          quality: 0.8,
          returnableOutputType: 'uri',
        });

        // Verificar tamanho após compressão
        const fileStat = await RNFS.stat(compressedUri);

        if (fileStat.size > 2 * 1024 * 1024) {
          Alert.alert(
            'Imagem ainda muito grande',
            'Tente usar uma imagem com resolução menor.',
          );
          setProducts(prev => {
            const updated = [...prev];
            updated[index].image = null;
            updated[index].imageTooLarge = true;
            return updated;
          });
          return;
        }

        // Atualizar imagem no estado
        updateProductImage(index, {
          uri: compressedUri,
          name: asset.fileName ?? `photo_${products[index].MATNR}.jpg`,
          type: asset.type ?? 'image/jpeg',
        });
      } catch (error) {
        console.error('Erro ao processar imagem:', error);
        Alert.alert('Erro', 'Não foi possível processar a imagem.');
      }
    }
  };

  const updateProductImage = (index, asset) => {
    setProducts(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        image: {
          uri: asset.uri,
          name: asset.fileName ?? `photo_${updated[index].MATNR}.jpg`,
          type: asset.type ?? 'image/jpeg',
        },
        imageTooLarge: false,
      };
      return updated;
    });
  };

  useEffect(() => {
    if (selectedReason) {
      if (selectedReason === 'Outro motivo') {
        if (otherReason.trim().length > 0) {
          setErrorMessage('');
        } else {
          setErrorMessage(
            'Por favor, selecione um motivo para o cancelamento.',
          );
        }
      } else {
        setErrorMessage('');
      }
    }
  }, [selectedReason, otherReason]);

  const validateExchange = () => {
    let errorMessage = '';
    products.forEach((prod, index) => {
      if (prod?.quantity > 0) {
        if (prod?.reason === '') {
          errorMessage += `O produto ${prod?.ARKTX} precisa de um motivo de troca. \n`;
        }
        if (!prod?.image) {
          errorMessage += `O produto ${prod?.ARKTX} precisa de uma foto. \n`;
        }
        if (prod?.reason === 3 && !prod?.description.trim()) {
          errorMessage += `O produto ${prod?.ARKTX} com a razão "Outro" precisa de uma descrição. \n`;
        }
      }
    });

    if (errorMessage) {
      setValidationError(errorMessage);
      return false;
    } else {
      setShowModal(true);
      return true;
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmExchange = async () => {
    exchange();
    setShowModal(false);
  };

  const exchange = async () => {
    setLoading(true);
    const formData = new FormData();

    products.forEach((prod, index) => {
      if (prod?.quantity > 0) {
        formData.append(`order`, item['@attributes']?.ORDEM);
        formData.append(`products[${index}][sku]`, prod?.MATNR);
        formData.append(
          `products[${index}][reason]`,
          reasons[prod?.reason]?.reason,
        );
        formData.append(
          `products[${index}][quantity]`,
          prod?.quantity?.toString(),
        );
        if (prod?.description) {
          formData.append(`products[${index}][description]`, prod?.description);
        }

        if (prod?.image) {
          formData.append(`products[${index}][image]`, {
            uri: prod?.image?.uri,
            name: `photo_${prod?.MATNR}.jpg`,
            type: 'image/jpeg',
          });
        }
      }
    });

    const response = await ExchangeProductsService.ExchangeProductRequest(
      formData,
    )
      .then(res => {
        if (res) {
          logEvent(analyticsInstance, 'exchange_request', {
            client_code: user?.clientCode,
            order_number: item['@attributes']?.ORDEM,
            order_value: parseFloat(item['@attributes']?.VALOR),
          });
          setToast(true);

          setTimeout(() => {
            navigate(AppRoutes.MAIN_TAB_SCREEN, {
              screen: AppRoutes.ORDERS,
              params: {
                force: true,
              },
            });
          }, 1500);
        }
      })
      .catch(err => {
        let errorMessage = 'Erro ao realizar pedido de troca';

        if (err.response) {
          const status = err.response.status;
          const data = err.response.data;

          if (data) {
            if (data.message) {
              errorMessage = data.message;
            } else if (data.error) {
              errorMessage = data.error;
            } else if (data.details) {
              errorMessage += `: ${data.details}`;
            } else {
              errorMessage += ` (HTTP ${status})`;
            }
          } else {
            errorMessage += ` (HTTP ${status})`;
          }
        } else if (err.message) {
          if (err.message.includes('Network Error')) {
            errorMessage = 'Erro de rede. Verifique sua conexão.';
          } else {
            errorMessage = err.message;
          }
        } else {
          errorMessage = 'Erro desconhecido.';
        }

        Alert.alert('Erro', String(errorMessage));
        goBack();
      });

    setLoading(false);
  };

  const isAnyProductWithQuantity = products.some(prod => prod?.quantity > 0);

  const [expandedIndex, setExpandedIndex] = useState(null);

  const reasons = [
    {
      value: 0,
      reason: 'Embalagem com avaria na entrega',
    },
    {
      value: 1,
      reason: 'Divergência da nota na entrega',
    },
    {
      value: 2,
      reason: 'Produto com alteração',
    },
    {
      value: 3,
      reason: 'Outro',
    },
  ];

  const handleInputChange = (index, field, value) => {
    setProducts(prevProducts => {
      const updatedProducts = [...prevProducts];
      updatedProducts[index] = {
        ...updatedProducts[index],
        [field]: value,
      };
      return updatedProducts;
    });
  };
  const hasLargeImage = products.some(prod => prod.imageTooLarge);

  const getMaxQuantity = prod => {
    const catalogProduct = catalogData.find(p => {
      return parseInt(p.sku, 10) === parseInt(prod.MATNR, 10);
    });

    if (!catalogProduct) return 0;

    const un = catalogProduct.un || 1;
    const kwmeng = parseInt(prod.KWMENG, 10) || 0;

    if (prod.reason === 0 || prod.reason === 1) {
      return kwmeng;
    } else if (prod.reason === 2 || prod.reason === 3) {
      return kwmeng * un;
    }
    return 0;
  };

  return (
    <KeyboardAvoidingView
      style={{flex: 1}}
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}>
      {toast && <Toast title="Pedido de troca enviado com sucesso!" />}
      <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
        <ScrollView
          contentContainerStyle={{flexGrow: 1, paddingHorizontal: 20}}
          keyboardShouldPersistTaps="handled">
          <Header />
          <View style={styles.containerHeader}>
            <SearchHeader onPress={goBack} title="Trocar produtos" />
          </View>

          {canExchange.some(value => value === true) ? (
            <>
              <View style={styles.content}>
                <Text style={styles.text}>
                  Lamentamos que você tenha recebido um produto com problemas.
                </Text>
                <Text style={styles.titleDescription}>
                  Qual produto você deseja trocar?
                </Text>
              </View>

              {products.map((prod, index) => {
                const isExpanded = expandedIndex === index;
                return (
                  <View key={index} style={styles.card}>
                    <TouchableOpacity
                      onPress={() =>
                        setExpandedIndex(isExpanded ? null : index)
                      }
                      style={styles.header}>
                      <Text style={styles.productText}>
                        {prod?.ARKTX}
                        {prod?.quantity > 0 ? ` (${prod?.quantity})` : ''}
                      </Text>
                      <Text style={styles.toggle}>
                        {isExpanded ? '▲' : '▼'}
                      </Text>
                    </TouchableOpacity>

                    {isExpanded && (
                      <View style={styles.form}>
                        <Text style={styles.label}>Motivo da troca</Text>
                        <View style={styles.inputWrapper}>
                          <FlatList
                            data={reasons}
                            keyExtractor={(item, index) => index.toString()}
                            nestedScrollEnabled={true}
                            scrollEnabled={false}
                            renderItem={({item}) => (
                              <Pressable
                                onPress={() => {
                                  handleInputChange(
                                    index,
                                    'reason',
                                    item.value,
                                  );
                                  handleInputChange(index, 'quantity', 0);
                                  setSelectedReason(item.value);
                                }}
                                style={styles.radioContainer}>
                                <View style={styles.radio}>
                                  {selectedReason === item.value && (
                                    <View style={styles.radioSelected} />
                                  )}
                                </View>
                                <Text style={styles.text}>{item.reason}</Text>
                              </Pressable>
                            )}
                          />
                        </View>

                        <Text style={styles.label}>
                          Descrição{prod?.reason === 3 ? ` (Obrigatório)` : ''}
                        </Text>
                        <TextInput
                          style={styles.input}
                          value={prod?.description}
                          onChangeText={value =>
                            handleInputChange(index, 'description', value)
                          }
                          placeholder="Digite a descrição"
                          placeholderTextColor="gray"
                        />

                        <Text style={styles.label}>
                          {prod?.reason === 0 || prod?.reason === 1
                            ? 'Caixas para troca'
                            : 'Garrafas/latas para troca'}
                        </Text>
                        <View style={styles.quantityContainer}>
                          {prod?.quantity > 0 ? (
                            <TouchableOpacity
                              onPress={() =>
                                handleInputChange(
                                  index,
                                  'quantity',
                                  prod?.quantity - 1,
                                )
                              }
                              disabled={toast}>
                              <Text style={styles.button}>-</Text>
                            </TouchableOpacity>
                          ) : (
                            <Text style={styles.button}> </Text>
                          )}

                          <TextInput
                            style={styles.input2}
                            value={prod?.quantity?.toString() || ''}
                            keyboardType="numeric"
                            returnKeyType="done"
                            onChangeText={text => {
                              const max = getMaxQuantity(prod);
                              const newValue = Math.min(
                                parseInt(text.replace(/[^0-9]/g, ''), 10) || 0,
                                max,
                              );
                              handleInputChange(index, 'quantity', newValue);
                            }}
                            editable={!toast}
                          />

                          {prod?.quantity < getMaxQuantity(prod) ? (
                            <TouchableOpacity
                              onPress={() =>
                                handleInputChange(
                                  index,
                                  'quantity',
                                  prod?.quantity + 1,
                                )
                              }
                              disabled={toast}>
                              <Text style={styles.button}>+</Text>
                            </TouchableOpacity>
                          ) : (
                            <Text style={styles.button}> </Text>
                          )}
                        </View>

                        <Text style={styles.label}>Foto do produto</Text>

                        {prod?.image ? (
                          <Image
                            source={{uri: prod.image.uri}}
                            style={{width: 100, height: 100}}
                            resizeMode="contain"
                          />
                        ) : null}
                        {prod?.imageTooLarge && (
                          <Text style={{color: 'red', marginTop: 5}}>
                            A imagem excede o tamanho máximo de 2MB.
                          </Text>
                        )}

                        <View style={{marginTop: 10}}>
                          <ButtonComponent
                            disabled={loading}
                            outlined={true}
                            onPress={() => openImageOptions(index)}
                            title={
                              prod?.image ? 'Trocar imagem' : 'Foto do produto'
                            }
                            width="100%"
                          />
                        </View>
                      </View>
                    )}
                  </View>
                );
              })}

              {errorMessage ? (
                <Text style={styles.errorText}>{errorMessage}</Text>
              ) : null}

              {validationError ? (
                <Text style={{color: 'red', marginTop: 10}}>
                  {validationError}
                </Text>
              ) : null}

              {loading && (
                <ActivityIndicator color={Colors.RedPallete.red} size={35} />
              )}

              <View style={{marginTop: 'auto', paddingBottom: 20}}>
                <ButtonComponent
                  title="Cancelar Troca"
                  width="100%"
                  onPress={goBack}
                />
                <View style={{marginTop: 10}}>
                  <ButtonComponent
                    disabled={
                      loading || !isAnyProductWithQuantity || hasLargeImage
                    }
                    outlined={true}
                    title="Solicitar Troca"
                    width="100%"
                    onPress={validateExchange}
                  />
                </View>
              </View>

              {showModal && (
                <View style={styles.modalContainer}>
                  <View style={styles.modalContent}>
                    <Text style={styles.modalTitle}>Resumo da Troca</Text>
                    {products
                      .filter(prod => prod?.quantity > 0)
                      .map((prod, idx) => (
                        <View key={idx} style={styles.productSummary}>
                          <Text style={styles.label}>{prod?.ARKTX}</Text>
                          <Text style={styles.label}>
                            {reasons[prod?.reason].reason}
                          </Text>
                          <Text style={styles.quantity}>
                            ({prod?.quantity} unidades)
                          </Text>
                        </View>
                      ))}
                    <View style={styles.modalButtons}>
                      <ButtonComponent
                        title="Voltar"
                        onPress={handleCloseModal}
                        width="48%"
                      />
                      <ButtonComponent
                        title="Confirmar"
                        onPress={handleConfirmExchange}
                        width="48%"
                      />
                    </View>
                  </View>
                </View>
              )}
            </>
          ) : null}
        </ScrollView>
      </TouchableWithoutFeedback>
    </KeyboardAvoidingView>
  );
};

export default ExchangeProduct;
